import * as React from "react"
import { Select as CSelect, SelectProps, FormControl } from "@chakra-ui/react"
import { useFormContext, FieldError } from "react-hook-form"
import { InputError } from "./InputError"
import { InputLabel } from "./InputLabel"

interface Props extends SelectProps {
  name: string
  options: { label: string; value: any }[]
  label?: string
  subLabel?: string
}

export const Select = ({ label, subLabel, placeholder, ...props }: Props) => {
  const {
    register,
    formState: { errors },
    setValue,
    getValues,
  } = useFormContext()
  const fieldError = errors?.[props.name] as FieldError | string

  React.useEffect(() => {
    const value = getValues(props.name)
    if (!props.options.find((opt) => opt.value === value)) {
      setValue(props.name, props.options.length > 0 ? props.options[0].value : "")
    }
  }, [props.options, getValues, props.name, setValue])

  return (
    <FormControl isInvalid={!!fieldError} isRequired={props.isRequired}>
      <InputLabel label={label} subLabel={subLabel} name={props.name} />
      <CSelect {...register(props.name)} variant="filled" {...props} mb={0}>
        {placeholder && (
          <option value="" disabled>
            {placeholder}
          </option>
        )}
        {props.options.map((option, index) => (
          <option
            key={index}
            value={typeof option === "string" || typeof option === "number" ? option : option.value}
          >
            {typeof option === "string" || typeof option === "number" ? option : option.label}
          </option>
        ))}
      </CSelect>
      <InputError error={fieldError} />
    </FormControl>
  )
}
